import styled from 'styled-components';

export const StyledMedicalLeaveFormCodesCheckboxes = styled.div`
   display: flex;
   gap: 20px;
`;
StyledMedicalLeaveFormCodesCheckboxes.displayName = 'StyledMedicalLeaveFormCodesCheckboxes';
